import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              分类索引
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              按类型浏览全部影视资源，快速找到你想看的
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
            {indexItems.map((item, idx) => (
              <a
                key={idx}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="flex items-center gap-4 bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/60 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-xl flex-shrink-0">
                  <i className={`${item.icon} text-xl text-primary-600`}></i>
                </div>
                <div className="min-w-0">
                  <div className="text-sm md:text-base font-semibold text-foreground-900">
                    {item.title}
                  </div>
                  <div className="text-xs text-foreground-400">{item.count}</div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}